import Vue from "vue";
import SearchBar from "@/components/ClinicsResult/SearchBar/SearchBar.vue";
import ClinicResultSubheader from "@/components/ClinicsResult/ClinicResultSubheader/ClinicResultSubheader.vue";
import ClinicResultHeader from "@/components/ClinicsResult/ClinicResultHeader/ClinicResultHeader.vue";
import NoResultArea from "@/components/ClinicsResult/NoResultArea/NoResultArea.vue";
import ServiceClinicCard from "@/components/ClinicsResult/ServiceClinicCard/ServiceClinicCard.vue";
import ServiceClinicCardSkeleton from "@/components/ClinicsResult/ServiceClinicCardSkeleton/ServiceClinicCardSkeleton.vue";
import ServiceAppointComponent from "@c/Home/Services/ServiceAppoint/ServiceAppoint.vue";
import SideModal from "@c/Util/SideModal/SideModal.vue";
import SearchError from "@/views/SearchError.vue";
import infiniteScroll from "vue-infinite-scroll";
import Service from "@/api/Services/Service";
import ServiceEntity from "@/components/Home/Services/ServiceEntity";
import * as LogoClinicarx from "@/assets/images/Logo_nova.png";
import Tenancy from "@/api/Services/Tenancy";
import GoogleAnalyticsEvents from "@/helpers/GoogleAnalyticsEvents";
import ServiceDefaultName from "@/api/Services/ServiceDefaultName";
import MapService from "@/api/Services/MapService";
import NotFoundPage from "@/views/NotFound/NotFoundPage.vue";
import AppointmentService from "@/api/Services/Appointment";
import moment from "moment";

import { bus } from "@/main";
import { Component } from "vue-property-decorator";
import { ServiceModal } from "@/components/Home/Services/ServiceInterface";
import { AddressInterface, GeoCoordinatesInterface } from "@/api/Interfaces/MapInterface";
import { ServiceDefaultNameInterface } from "@/api/Interfaces/ServiceDefaultNameInterface";
import { ResponseInterface } from "@/api/Interfaces/ResponseInterface";
import { ServiceInterface } from "@/api/Interfaces/ServiceInterface";
import { BIcon } from "bootstrap-vue"
import { mapGetters } from "vuex";
import { SelectTimeInterface } from "@/components/Home/Services/ServiceTimeSelect/SelectTimeInterface";

const ClinicsResultProps = Vue.extend({
  props: {
    address: {
      type: String,
      default: "",
    },
    zipCode: {
      type: String,
      default: null,
    },
    coordinates: {
      type: [Object as () => GeoCoordinatesInterface],
      default: null,
    },
    latitude: {
      type: Number,
      default: -25.42529645346497,
    },
    longitude: {
      type: Number,
      default: -49.240248152091446,
    },
    services: {
      type: Array,
      default: () => [],
    },
    selectedServiceDefaultName: {
      type: [Object as () => ServiceDefaultNameInterface],
      default: null,
    },
    pageSize: {
      type: Number,
      default: 6,
    },
    currentPage: {
      type: Number,
      default: 0,
    },
    totalPages: {
      type: Number,
      default: -1,
    },
    isScrolling: {
      type: Boolean,
      default: false,
    },
    selectedSort: {
      type: String,
      default: "Ordenar por",
    },
    tenancyId: {
      type: String,
      default: "",
    },
    headerLogo: {
      type: String || LogoClinicarx,
    },
  },
  directives: {
    infiniteScroll,
  },
});

Component.registerHooks(["beforeRouteLeave", "metaInfo"]);

@Component<ClinicsResult>({
  name: "ClinicsResult",
  components: {
    BIcon,
    "search-bar": SearchBar,
    "clinic-result-header": ClinicResultHeader,
    "clinic-result-subheader": ClinicResultSubheader,
    "service-clinic-card": ServiceClinicCard,
    "service-appoint": ServiceAppointComponent,
    SideModal,
    SearchError,
    "no-result-area": NoResultArea,
    "not-found": NotFoundPage,
    "service-clinic-card-skeleton": ServiceClinicCardSkeleton
  },
  computed: mapGetters(["getDate", "getTime", "getAppointmentDate", "getSearchDate"]),

  watch: {
    getDate() {
      this.cx_times = {};
      this.cx_services = this.services;
      this.cx_currentPage = this.currentPage;
      this.cx_totalPages = this.totalPages;
      this.getServices();
    },
  }
})
export default class ClinicsResult extends ClinicsResultProps {
  cx_zipCode = window.sessionStorage.getItem("zipcode")
    ? JSON.parse(window.sessionStorage.getItem("zipcode") || "")
    : this.zipCode;
  cx_address = this.address || window.sessionStorage.getItem("address");
  cx_coordinates = window.sessionStorage.getItem("coordinates")
    ? JSON.parse(window.sessionStorage.getItem("coordinates") || "")
    : this.coordinates;
  cx_latitude = this.latitude;
  cx_longitude = this.longitude;
  cx_services = this.services;
  cx_pageSize = this.pageSize;
  cx_currentPage = this.currentPage;
  cx_totalPages = this.totalPages;
  cx_isScrolling = this.isScrolling;
  cx_selectedServiceDefaultName = this.selectedServiceDefaultName;
  cx_selectedSort = this.selectedSort;
  cx_header_logo = this.headerLogo || LogoClinicarx;
  cx_Service = new Service();
  cx_serviceModal: ServiceModal | null = null;
  cx_serviceModalEmpty: ServiceModal | null = null;
  cx_noResults = false;
  cx_tenancy_id = "";
  cx_dayHasHoursAvailable = false;
  cx_selectedDate = ""
  cx_logo_url = LogoClinicarx;
  cx_loading = true;
  cx_locationBlocked = false;
  showUnavailablePage = false;
  
  cx_isConsultingGeoCoordinates!: boolean;
  cx_isConsultingGeoCoordinatesCheckBox!: boolean;
  cx_allowAccessMyLocation!: boolean;

  clinic_ids = [];

  getDate!: string;
  getClinicId!: string;
  getTime!: SelectTimeInterface;
  getAppointmentDate!: string;
  getSearchDate!: string;
  cx_times = {};

  cx_zipCodeCheckBox!: boolean;
  cx_zipCodeIsVisible!: boolean;
  cx_isConsultingZipCode!: boolean;
  cx_isInvalidCep!: boolean;
  cx_checkboxZipCodeIsActive!: string;
  cx_directSearch!: boolean;

  cx_ServiceDefaultName!: ServiceDefaultName;
  cx_serviceCategories!: Array<ServiceDefaultName>;
  cx_buttonActive!: string;
  cx_prerender!: boolean;
  cx_notFound = false;
  cx_showNotFoundPage = false;
  cx_noNearbyClinics = false;
  /**
   * -----------------------------------------
   * EVENTS
   * -----------------------------------------
   */

  beforeMount(): void {
    this.cx_loading = true;
    this.cx_serviceModalEmpty = {
      selectedService: null,
      clinic: null,
      modalOpened: false,
    };
    this.cx_isConsultingGeoCoordinates = false;
    this.cx_isConsultingGeoCoordinatesCheckBox = false;
    this.cx_allowAccessMyLocation = false;
    this.cx_prerender = !!this.$route.query.prerender && this.$route.query.prerender == "1";

    this.cx_serviceModal = this.cx_serviceModalEmpty;
    this.cx_loading = true;
    this.cx_notFound = false;
    this.showUnavailablePage = false;
    this.cx_dayHasHoursAvailable = false;
    this.cx_selectedDate = ""; 
  }

  mounted() {
    GoogleAnalyticsEvents.loadResultPage();
    window.addEventListener("scroll", this.onScroll);
    if (!this.cx_coordinates && !this.cx_prerender) {
      this.openConfirmMyLocationModal();
    } else if (!this.cx_selectedServiceDefaultName) {
      this.getServiceByServiceName();
    }
    this.getTenancy();
  }

  metaInfo() {
    return {
      title: `${this.cx_selectedServiceDefaultName?.search_name || ""} | Clinicarx `,
      meta: [
        {
          vmid: "description",
          name: "description",
          content: `${this.cx_selectedServiceDefaultName?.meta_description || ""} `,
        },
      ],
    };
  }

  beforeRouteLeave(to: any, from: any, next: any) {
    if (this.cx_serviceModal?.modalOpened) {
      this.clearServiceModal();
      next(false);
    } else next();
  }

  setAddress(address: AddressInterface): void {
    this.cx_address = address.street
      ? `${address.street}, ${address.city}/${address.state}`
      : `${address.city}/${address.state}`;
  }
  consultZipCode(): void {
    this.cx_isConsultingZipCode = true;

    MapService.getLocationByZipCode(this.cx_zipCode)
      .then((response) => {
        const address: AddressInterface = response as AddressInterface;
        if (address) {
          this.cx_isInvalidCep = false;
          this.setAddress(address);

          MapService.getGeoCoordinatesByAddress(address).then((response) => {
            this.cx_coordinates = response as GeoCoordinatesInterface;
          });
        } else {
          this.cx_isInvalidCep = true;
          this.cx_coordinates = {} as GeoCoordinatesInterface;
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => (this.cx_isConsultingZipCode = false));
  }

  noAddressFound() {
    this.cx_notFound = true;
  }

  activateMyLocation(): void {
    this.cx_zipCode = this.cx_zipCode === null || this.cx_zipCode.length > 0 ? "" : null;

    if (!navigator.geolocation) {
      alert("O seu navegador não suporta Geolocalização");
      return;
    }
    this.cx_isConsultingGeoCoordinates = true;
    navigator.geolocation.getCurrentPosition(
      (response) => {
        this.cx_coordinates = {} as GeoCoordinatesInterface;
        this.cx_coordinates.latitude = response.coords.latitude;
        this.cx_coordinates.longitude = response.coords.longitude;
        this.cx_totalPages = -1;
        this.cx_currentPage = 0;
        this.getServices();
        MapService.getAddressByGeoCoordinates(response.coords.latitude, response.coords.longitude)
          .then((response) => {
            this.cx_notFound = false;
            const address: AddressInterface = response as AddressInterface;
            if (address) {
              this.setAddress(address);
            } else {
              throw new Error(address);
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => (this.cx_isConsultingGeoCoordinates = false));
        if (!this.cx_selectedServiceDefaultName) {
          this.getServiceByServiceName();
        }
      },

      (_error) => {
        this.cx_isConsultingGeoCoordinates = false;
      }
    );
  }

  getNavigatorGeolocationState(): void {
    navigator.permissions && navigator.permissions.query({name: 'geolocation'})
    .then((PermissionStatus) => {
        if (PermissionStatus.state === 'denied') {
          this.cx_locationBlocked = true;
          bus.$emit("showLoading", false);
        } else {
          this.activateMyLocation();
        }
    })
  }

  openConfirmMyLocationModal(): void {
    this.$bvModal.show("confirm-my-location-modal");
  }

  closeConfirmMyLocationModal(allowAccess: boolean): void {
    this.$bvModal.hide("confirm-my-location-modal");

    if (allowAccess) {
      GoogleAnalyticsEvents.allowLocation();
      this.cx_allowAccessMyLocation = true;
      this.getNavigatorGeolocationState();
    } else {
      GoogleAnalyticsEvents.dontAllowLocation();
      this.cx_isConsultingGeoCoordinatesCheckBox = false;

      if (this.cx_directSearch) {
        this.cx_directSearch = false;
      }
      this.getServiceByServiceName();
    }
    this.cx_notFound = true;
    this.cx_loading = true;
  }

  confirmMyLocation(): void {
    this.closeConfirmMyLocationModal(true);
  }

  getServiceByServiceName(): void {
    ServiceDefaultName.getByServiceName(this.$route.params.serviceName)
      .then((response) => {
        const responseData = response.data as ResponseInterface;
        if (responseData.data[0]) {
          this.showUnavailablePage = false;
          this.cx_selectedServiceDefaultName = responseData.data[0];
          this.$router.replace({
            params: {
              serviceName: this.cx_selectedServiceDefaultName.url_parameter,
            },
          });
          this.getServices();
        } else {
          this.cx_showNotFoundPage = true;
        }
      })
      .catch((error) => {
        this.showUnavailablePage = true;
        console.log(error);
      })
    }

  changeServiceDefaultName(ServiceDefaultName: any): void {
    this.cx_selectedServiceDefaultName = ServiceDefaultName;
    sessionStorage.setItem("service", JSON.stringify(this.cx_selectedServiceDefaultName));
  }

  getServices(): void {
    if (
      (this.cx_currentPage >= this.cx_totalPages && this.cx_totalPages != -1) ||
      !this.cx_selectedServiceDefaultName ||
      (!this.cx_coordinates && !this.cx_prerender)
    ) {
      return;
    }
    let sortBy = this.cx_selectedSort;
    if (this.cx_selectedSort === "Ordenar por") sortBy = "distance ASC";

    this.cx_services = (this.cx_currentPage === 0) ? [] : this.cx_services;

    this.cx_currentPage++;
    const filters = {
      min_price: 5,
      near_by: this.cx_prerender
        ? null
        : `${this.cx_coordinates.latitude},${this.cx_coordinates.longitude},${sortBy}`,
      service_default_name_id: this.cx_selectedServiceDefaultName.id,
      tenancy_id: this.tenancyId,
    };
    const includes = ["clinic.address.city.state", "clinic.phones", "service_default_name"];

    if (this.cx_currentPage == 1) {
      this.cx_loading = true;
    }
    this.cx_Service
      .index(this.cx_currentPage, this.cx_pageSize, filters, includes, sortBy)
      .then((response) => {
        this.showUnavailablePage = false;
        this.cx_notFound = false;
        const responseData = response.data as ResponseInterface;
        const data = responseData.data;
        if ((!data.data || data.data.length <= 0) && this.cx_currentPage == 1) {
          this.cx_noNearbyClinics = true;
          this.cx_loading = false;
          GoogleAnalyticsEvents.serviceWithoutClinic();
        } else {
          this.cx_noNearbyClinics = false;
          this.cx_services = this.cx_services.concat(data.data);
          this.cx_totalPages = data.last_page;
          this.clinic_ids = data.data.map((service: any) => service.clinic.id);
          this.getHoursAvailableClinics();
        }
      })
      .catch((error) => {
        this.showUnavailablePage = true;
      });
  }

  getHoursAvailableClinics(): void {
    const date = new Date();
    const year = date.getFullYear().toString();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const currentDate = `${year}-${month}-${day}`;

    const formattedSelectedDate = moment(this.getDate || currentDate).format('YYYY-MM-DD');

    AppointmentService.getClinicGroupAvailableHours(formattedSelectedDate, this.clinic_ids)
    .then((response: any) => {
      Object.keys(response.data.data).filter((clinicId) => {
        this.showUnavailablePage = false;
        response.data.data[clinicId] = response.data.data[clinicId].filter((hour: any, index: any) => {
          hour.id = index;
          return hour.available;
        });
        
        if (response.data.data[clinicId].length === 0) {
          response.data.data[clinicId] = false;
        }
      });
      this.cx_times = {
        ...this.cx_times,
        ...response.data.data,
      }      
    })
    .catch((error) => {
      this.showUnavailablePage = true;
    })
    .finally(() => {
      this.cx_loading = false;
    });
  }

  changeSearchSort(sortBy: any): void {
    this.cx_selectedSort = sortBy;
    this.cx_currentPage = 0;
    this.cx_services = [];
    this.cx_totalPages = 1;
    this.getServices();
  }

  getSlugId() {
    return this.$route.name == "SearchServicesTenancy" ? this.$route.params.slugId : "";
  }

  getTenancy() {
    if (!this.getSlugId()) return false;

    Tenancy.getTenancy(this.getSlugId()).then((response: any) => {
      const responseData = response as ResponseInterface;
      if (!responseData) {
        this.$router.push({ name: "Home" });
      } else {
        this.cx_tenancy_id = responseData.data.id;
      }
    });
  }

  changeSearch(
    coordinates: GeoCoordinatesInterface,
    serviceDefaultName: ServiceDefaultNameInterface,
    address: string
  ): void {
    this.cx_selectedServiceDefaultName = serviceDefaultName;
    this.cx_coordinates = coordinates;
    this.cx_address = address;

    this.$router.replace({
      params: {
        serviceName: this.cx_selectedServiceDefaultName.url_parameter,
      },
    });
    this.changeSearchSort("Ordenar por");
    sessionStorage.setItem("coordinates", JSON.stringify(this.cx_coordinates));
    sessionStorage.setItem("address", this.cx_address);
  }

  onScroll(): void {
    if (this.cx_isScrolling != null) this.cx_isScrolling = window.scrollY > 0;
  }

  scrollToTop(): void {
    window.scrollTo(0, 0);
  }

  clearServiceModal(): void {
    this.cx_serviceModal = this.cx_serviceModalEmpty;
    this.$store.commit("setCpf", "");
    this.$store.commit("setPatientData", null);
  }

  resetPagination(): void {
    this.cx_currentPage = 0;        
    this.cx_totalPages = -1;
  }

  closeModal(event: Event): void {
    
    this.resetPagination();
    this.getServices();
    if (!event) this.clearServiceModal();
  }

  openModalHandler(service: ServiceInterface): void {
    GoogleAnalyticsEvents.scheduleAppointment();
    this.$store.commit("setService", service);
    this.$store.commit("setClinicId", service.clinic_id);
    this.cx_serviceModal = {
      selectedService: service,
      clinic: null,
      modalOpened: true,
    };
  }

  openScheduleModal(service: ServiceInterface, hoursAvailable: boolean ): void {
    this.cx_dayHasHoursAvailable = hoursAvailable;
    this.openModalHandler(service);
    this.$store.commit("setPatient", {});
  }
}
